<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keyword"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择区域"
        v-model="searchData.areaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.sourcesDangerIdentifyStatus"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择辨识状态"
        clearable
      >
        <el-option :key="0" label="待辨识" :value="0"></el-option>
        <el-option :key="1" label="已辨识" :value="1"></el-option>
        <el-option :key="2" label="已逾期" :value="2"></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :span-method="spanMethod"
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
      >
        <el-table-column label="序号" prop="spanIndex" width="50"></el-table-column>
        <el-table-column
          label="辨识计划"
          width="180"
          prop="recognitionPlanName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="辨识截止时间" width="180" prop="planTimeEnd" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.planTimeEnd && dayjs(scope.row.planTimeEnd).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="辨识状态"
          width="180"
          prop="statusText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="作业活动名称"
          width="180"
          prop="jobName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="编号"
          width="120"
          prop="jobNo"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属区域"
          prop="jobActivityArea"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="作业步骤"
          width="180"
          prop="jobStep"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="危险源或潜在事件"
          width="180"
          prop="hiddenEvent"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="危险有害因素分类"
          width="180"
          prop="harmElementType"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="可能导致的事故类型"
          width="180"
          prop="accidentType"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="是否重点管控"
          width="110"
          prop="isFocusControl"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isFocusControl === 0 || scope.row.isFocusControl === '0'"
              >否</span
            >
            <span v-else-if="scope.row.isFocusControl === 1 || scope.row.isFocusControl === '1'"
              >是</span
            >
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          label="伤亡财产损失预测"
          width="180"
          prop="assetsCasualtyPredict"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsJob(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <identify-job-form
      v-if="formDialog"
      :formProps="formProps"
      :formData="formData"
      @refreshList="refreshList"
      @cancel="handleCancel"
    ></identify-job-form>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { JobSourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import utils from '@/components/safety/enumField/utils'
import IdentifyJobForm from './IdentifyJobForm'

const jobSourcesDangerIdentifyApi = new JobSourcesDangerIdentifyApi()
const areaApi = new AreaApi()

export default {
  name: 'identify-job-table',
  components: {
    TableOperateButton,
    IdentifyJobForm,
    // PersonSelect,
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 15,
      formProps: {
        title: '新增作业活动辨识',
        editType: 'create',
        visible: true,
      },
      value: '',
      formDialog: false,
      formData: {},
      areaList: [],
      // 设备设施清单
      tableData: [],
      loading: false,
      total: 0,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      position: 0,
      spanArrObj: {},
      spanIndex: 1,
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsJob() {
      return (val) => {
        return [
          {
            text: '提交',
            click: () => {
              return this.handleEvent(val, 'submit')
            },
            isShow: this.$hasAccess('submit') && val.status === 0,
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update') && val.status === 0,
          },
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
        ]
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  created() {
    // 1为设备设施 2为作业活动 3为基础管理
    if (
      this.$route.query.planTaskId &&
      this.$route.query.tagType &&
      this.$route.query.tagType == 2 &&
      this.$route.query.mode
    ) {
      this.handleEvent(
        { id: this.$route.query.planTaskId },
        this.$route.query.mode === 'approve' ? 'submit' : 'read'
      )
    }
    this.searchList()
    this.getAreaList()
  },
  methods: {
    /**
     * 刷新列表
     */
    refreshList() {
      if (this.$route.query.id) {
        this.$router.replace(this.$route.path)
        this.$router.go(-1)
      }
      this.formDialog = false
      this.findList()
    },
    /**
     * 返回
     */
    handleCancel() {
      if (this.$route.query.id) {
        this.$router.replace(this.$route.path)
        this.$router.go(-1)
      }
      this.formDialog = false
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      switch (operation) {
        case 'create':
          this.initDialog(operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'submit':
          this.initDialog(row, operation)
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formData = this.$options.data().formData
      this.formData.id = row.id
      this.formDialog = true
    },
    async submit(row) {
      const [err, res] = await jobSourcesDangerIdentifyApi.submit({
        body: {
          sourcesDangerRecognitionPlanTaskId: row.id,
        },
      })
      if (!err) {
        this.findList()
      }
    },
    // 搜索 equip 设备设施 job 作业活动
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    async findList() {
      this.spanIndex = 1
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await jobSourcesDangerIdentifyApi.pagedListQuery(data)

      if (!err) {
        this.tableData = this.toList(res.items)
        this.getSpanArr()
        this.total = res.totalCount
        this.loading = false
      }
    },
    toList(list) {
      return list.reduce((pre, item) => {
        if (item.data && item.data.length) {
          item.data.forEach((i) => {
            i.taskId = item.id
            pre.push({
              ...i,
              ...item,
            })
          })
        } else {
          item.taskId = item.id
          pre.push(item)
        }
        return pre
      }, [])
    },
    getSpanArr() {
      this.position = 0
      this.spanArrObj = {}
      const needSpan = ['taskId']
      needSpan.forEach((item) => {
        this.rowspan(item)
      })
    },
    // 获取合并行参数(数组)
    rowspan(prop) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = 0
          item.spanIndex = this.spanIndex
          this.spanIndex += 1
        } else if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
          this.spanArrObj[prop][this.position] += 1
          this.spanArrObj[prop].push(0)
          item.spanIndex = this.spanIndex
        } else {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = index
          item.spanIndex = this.spanIndex
          this.spanIndex += 1
        }
      })
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 3, 4, 5, 6, 13].includes(columnIndex)) {
        const _row = this.spanArrObj.taskId[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style></style>
